import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class SlickAriaFixService {
  private platformId = inject(PLATFORM_ID);

  init(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const syncInert = () => {
      document.querySelectorAll<HTMLElement>('.slick-slide').forEach((slide) => {
        slide.inert = slide.getAttribute('aria-hidden') === 'true';
      });
    };

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some(
        (m) => m.type === 'attributes' && m.attributeName === 'aria-hidden',
      );
      if (relevant) syncInert();
    });

    observer.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['aria-hidden'],
    });

    syncInert();
  }
}
